import React, { useContext, useMemo } from 'react';
import Context from './TransportRoadsCalculatorContext';
import { IdRoute } from '../../../../../../types';
import useServiceReducer from '../../../../../../shared/hooks/useServiceReducer';
import calculatorTransportPavmentsService from '../../../../../../services/calculatorTransportPavmentsService';
import calculatorSectorReducer from './TransportRoadsCalculatorReducer';
import MainContext from '../../../../../App/MainProvider/context';

const CalculatorSectorProvider: React.FC<IdRoute> = ({ id: operationId, children }) => {
  const { inSuperUserMode, inGuidanceServiceMode } = useContext(MainContext);
  const [calculatorSectorContext, , , , , reload] = useServiceReducer(
    calculatorTransportPavmentsService.getCalculatorTransportPavmentsSectorContext,
    calculatorSectorReducer,
    operationId,
    [inSuperUserMode(), inGuidanceServiceMode()]
  );

  const value = useMemo(
    () =>
      calculatorSectorContext && {
        calculateId: calculatorSectorContext.calculateId,
        operationId: calculatorSectorContext.operationId,
        country: calculatorSectorContext.country,
        sector: calculatorSectorContext.sector,
        sectorId: calculatorSectorContext.sectorId,
        landUseChange: calculatorSectorContext.landUseChange,
        roadPavementTransport: calculatorSectorContext.roadPavementTransport,
        emissionsDevelopmentBuildingConstruction:
          calculatorSectorContext.emissionsDevelopmentBuildingConstruction,
        emissionsRoadMaintenanceActivities:
          calculatorSectorContext.emissionsRoadMaintenanceActivities,
        emissionsPurchasedElectricity: calculatorSectorContext.emissionsPurchasedElectricity,
        totalConstructionOverriden: calculatorSectorContext.totalConstructionOverriden,
        totalOperationOverriden: calculatorSectorContext.totalOperationOverriden,
        isFinished: calculatorSectorContext.isFinished,
        reload,
      },
    [calculatorSectorContext, reload]
  );

  return value && <Context.Provider value={value}>{children}</Context.Provider>;
};

export default CalculatorSectorProvider;
